module.exports = __webpack_public_path__ + "img/健康_四方連續_彩稿.90969329.png";